import React, { Fragment } from "react";
import { Button } from "react-bootstrap";
import check from "../../../../assets/check.png";
import "./modal.scss";

const AddProcedureModal = ({okayClickHandler}) => {
  return (
    <div className="myschedule-modal">
      <div className="text-center align-items-center">
        <img
          src={check}
          alt="Success"
          style={{ width: "60px", height: "60px" }}
        />
        <p className="font-weight-bold my-1 modal-heading" >
          Procedure added successfully
        </p>
        <p className="mt-2 mb-3 modal-paragraph" >
          Please click “<b>Open more slots</b>” to configure your time range for
          <br /> procedure appointments
        </p>
      </div>
      <div className="d-flex flex-column justify-content-center align-items-center">
        <Button
          className="border-0 rounded-pill "
          style={{
            backgroundColor: "#17BAE0",
            color: "#fff",
            width: "140px",
            height: "44px",
          }}
          onClick={okayClickHandler}
        >
          Okay
        </Button>
      </div>
    </div>
  );
};

export default AddProcedureModal;
